import React, {useMemo} from 'react';
import {
    sanitizePostal,
    buildJobURL,
    cleanJobTitle,
    getFullState,
    removeMainCat,
    formatShortDate,
    dateDiffInDays

} from '../helpers/helpers.js';

const JobCard = ({ job, isActive, onClick, onKeyDown }) => {
    const {
        job_order_id,
        job_title,
        job_category,
        job_category_id,
        job_postal,
        job_city,
        job_state_abbr,
        modified_at,
    } = job.fields;

    const jobTitle = cleanJobTitle(job_title[0]);
    const jobCity = job_city?.[0] ?? '';
    const jobStateAbbr = job_state_abbr?.[0] ?? '';
    const jobCategory = job_category?.[0] ?? '';
    const jobCatId = job_category_id?.[0] ?? '';
    const jobModifiedDate = modified_at?.[0] ?? '';
    const jobPostal = sanitizePostal(job_postal?.[0]);

    const jobOrderId = job_order_id?.[0] ?? '';
    const jobId = `${jobOrderId}-${jobPostal}`;
    const jobPostedDateFromToday = useMemo(() => dateDiffInDays(modified_at?.[0] ?? ''), [modified_at]);

    return (
        <li className={`job-card ${isActive ? 'active' : ''}`} data-id={jobId}>
        <a
            href={buildJobURL(jobCategory, jobCity, jobStateAbbr, jobPostal, jobOrderId, jobCatId)}
            className="job-link"
            onClick={(e) => {
            e.preventDefault();
            onClick?.(e);
            }}
            onKeyDown={(e) => {
            if (e.key === "Enter" || e.key === " ") {
                e.preventDefault();
                onClick?.(e);
            }
            }}
        >
            <h2 className="h3 job-title">{jobTitle}</h2>
            <div className="job-loc">{jobCity}, {jobStateAbbr}</div>
            <div className="job-meta">
            <span className="job-card__loc">{getFullState(jobStateAbbr)}</span>
            <span className="job-card__discipline">{removeMainCat(jobCategory)}</span>
            {/* <span className='job-card__posted-date'>{formatShortDate(jobModifiedDate)}</span> */}
            <span className="job-card__posted-date">{jobPostedDateFromToday}</span>
            </div>
        </a>
        </li>
    );
};

export default JobCard;
